import { apiCalendarFrequencies } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'calendar-frequencies';

const config = [
  { actionType: 'getAll', apiPath: apiCalendarFrequencies, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiCalendarFrequencies}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
